import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "../Components/Contactuspage.css";
import { collection, getDocs, query, where, addDoc } from "firebase/firestore";
import { db } from "../firebase-config";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Contactuspage = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  /* ================= FETCH CONTACT DATA ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Contact")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setContactData(data[0]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* ================= SUBMIT ================= */
 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setSending(true);

    // Save to Firestore
    await addDoc(collection(db, "contactMessages"), {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      createdAt: new Date(),
    });

   
    // console.log("EmailJS Success:", response);

   toast.success("Message sent successfully!");

    setFormData({
      name: "",
      email: "",
      message: "",
    });
  } catch (error) {
    toast.error("EmailJS Error:", error);

    toast.error(
      error?.text ||
        error?.message ||
        "Failed to send message. Check console."
    );
  } finally {
    setSending(false);
  }
};
// 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
    <>
      <section className="contact-section">
         <ToastContainer position="top-right" autoClose={2000} />
        <div className="overlay"></div>

        <div className="contact-container">

          {/* LEFT SIDE */}
          <div className="contact-info">
            <h2>{contactData?.title || "Contact Us"}</h2>

            <p>
              {contactData?.description ||
                "We are here to assist you anytime. Feel free to reach out to us."}
            </p>

            <div className="info-item">
              <FaMapMarkerAlt className="icon" />
              <div>
                <h4>Address</h4>
                <p>{contactData?.address || "Chennai, India"}</p>
              </div>
            </div>

            <div className="info-item">
              <FaPhoneAlt className="icon" />
              <div>
                <h4>Mobile Number</h4>
                <p>+966 &nbsp;{contactData?.mobilenumber || "+91 00000 00000"}</p>
              </div>
            </div>

            <div className="info-item">
              <FaEnvelope className="icon" />
              <div>
                <h4>Email</h4>
                <p>{contactData?.email || "masmobilityservices@email.com"}</p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE FORM */}
          <div className="contact-form">
            <h3>Send Message</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <textarea
                name="message"
                placeholder="Type your message..."
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <button type="submit" disabled={sending}>
                {sending ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

        </div>
      </section>

      {/* MAP */}
      <section className="map-section">
        <div className="map-header">
          <h2>Our Location</h2>
        </div>

        <div className="map-container">
          {loading ? (
            <p>Loading map...</p>
          ) : (
            <iframe
              title="location-map"
              src={
                contactData?.mapUrl ||
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d950648.0440662403!2d38.5516310370137!3d21.45010982520586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d01fb1137e59%3A0xe059579737b118db!2sJeddah%20Saudi%20Arabia!5e0!3m2!1sen!2sin!4v1780391095045!5m2!1sen!2sin" 
              }
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          )}
        </div>
      </section>
    </>
  );
};

export default Contactuspage;